module.exports = __webpack_public_path__ + "img/JAOC_POP_AgedCheese_square.e24f5bbf.png";